<template>
  <div>
      <RegistrationClosed/>
  </div>
</template>

<script>
import RegistrationClosed from '../../components/academic/RegistrationClosed.vue'
export default {
  components: { RegistrationClosed },
 
}
</script>

<style>

</style>